<template>
  <div class="Note">
    <div class="tab-list">
        <el-tabs v-model="activeName" @tab-click="handleClick" ref='tabs'>
            <el-tab-pane label="我的笔记" name="single">

                <div class="edit clear">
                    <el-input
                        type="textarea"
                        :rows="4"
                        placeholder="在此刻记录你的课程笔记…"
                        maxlength="90"
                        show-word-limit
                        v-model="noteData">
                        </el-input>
                        <div class="position">
                            <el-checkbox v-model="checked" class="float-left">私密笔记</el-checkbox>
                            <el-button type="primary" class="float-right" @click="postNote">发布笔记</el-button>
                        </div>

                        <div class="comment-list">
                            <ul>
                                <li v-for="(item, index) in notesinfo" :key="index">
                                        <div class="comment-head">
                                            <div class="img">
                                                <img v-lazy="item.customeratturl" :alt="item.customername">
                                            </div>
                                            <div class="title">
                                                <p class="name">{{item.customername}} <span class="type" v-if="item.ispublic == 0">私密</span></p>
                                                <p class="time">{{item.datetime}}</p>
                                            </div>
                                        </div>
                                        <div class="comment-msg">
                                            <p class="msg">{{item.content}}</p>

                                             <div class="position">
                                                <!-- <p class="icon-zan active" @click="good(item.noteid)">赞（{{item.praisecount}}）</p> -->
                                                <p class="icon-del" @click="del(item.noteid)">删除</p>
                                            </div>
                                        </div>
                                </li>
                                <!-- 评论列表区域 -->
                                <p v-if="nextpage && notesinfo.length >= 10" class="next-page" @click="nextPage">下一页</p>
                                <p v-if="loading" class="next-page">加载中...</p>
                                <p v-if="noMore" class="next-page">没有更多了</p>
                            </ul>
                        </div>
                        
                        
                </div>
                <!-- 文本填写区域 -->

            </el-tab-pane>
            <el-tab-pane label="全部笔记" name="all">
                <div class="comment-list">
                            <ul>
                                <li v-for="(item, index) in notesinfo" :key="index">
                                        <div class="comment-head">
                                            <div class="img">
                                                <img v-lazy="item.customeratturl" :alt="item.customername">
                                            </div>
                                            <div class="title">
                                                <p class="name">{{item.customername}}</p>
                                                <p class="time">{{item.datetime}}</p>
                                            </div>
                                        </div>
                                        <div class="comment-msg">
                                            <p class="msg">{{item.content}}</p>

                                            <div class="position">
                                                <!-- <p class="icon-zan active" @click="good(item.noteid)">赞（{{item.praisecount}}）</p> -->

                                                <!-- 自己发布的展示删除 -->
                                                <p class="icon-del" @click="del(item.noteid)" v-if="item.ismine == 1">删除</p>
                                            </div>
                                        </div>
                                </li>
                                <p v-if="nextpage && notesinfo.length >= 10" class="next-page" @click="nextPage">下一页</p>
                                <p v-if="loading" class="next-page">加载中...</p>
                                <p v-if="noMore" class="next-page">没有更多了</p>
                            </ul>
                            
                    </div>
                    <!-- 评论列表区域 -->
            </el-tab-pane>

        </el-tabs>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import {getCourseMyNotes, uploadCourseNotes, getAllCourseNotes, deleteMyCourseNotes} from 'api/course'
export default {
    name: 'Note',
    props: ['studyData'],
    data() {
        return {
            userIsLogin: this.user().isLogin, // 登录状态
            checked: false, // 私密笔记
            noteData: '',    // 笔记
            activeName: 'single',
            notesinfo: [],  // 笔记列表
            nodeDataApi: { // 笔记接口参数
                courseid: this.$route.query.courseid,
                page: 1,
                pagesize: 10
            },
            loading: false,
            noMore: false,
            nextpage: true,
        }
    },
    mounted() {
        this.handleClick(this.activeName)
    },
    methods: {
        scrollTop() {   // 回到顶部
            // this.$refs.tabs.scrollTop = 0
            // window.scrollTo(0,0)
            // window.scrollTo(0, 0);
        },
        handleClick(val) {
            let name = val

            // 切换类别时初始化笔记页数
            this.nodeDataApi.page = 1

            // 初始化按钮
            this.loading = false,
            this.noMore = false,
            this.nextpage = true
            
           
            if (val.name) {
                name = val.name
            }

            

            if (name == 'single') {
                this.singleNoteList()
            } else {
             console.log(name)

                this.allNoteList()
            }
        },
        nextPage() { // 翻页
            
            this.nodeDataApi.page ++
            
            if (this.activeName == 'single') {
                this.singleNoteList()
            } else {
                this.allNoteList()
            }

        },
        singleNoteList() {  // 我的笔记
            this.setLoading(true)
            getCourseMyNotes({
                data: this.nodeDataApi,
                success:data => {
                    console.log('getCourseMyNotes', data)
                    // this.notesinfo = data.data.notesinfo
                    this.NodeData(data.data.notesinfo)
                    this.setLoading(false)
                },
                error:data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        allNoteList() { // 全部笔记
            this.setLoading(true)
            getAllCourseNotes({
                data: this.nodeDataApi,
                success:data => {
                    // console.log('allNoteList', data)
                    // this.notesinfo = data.data.notesinfo
                    this.NodeData(data.data.notesinfo)
                    this.setLoading(false)
                },
                error:data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        NodeData(notesinfo) {
            if (this.nodeDataApi.page == 1) {
                this.notesinfo = notesinfo
            } else {
                this.$nextTick(() => {
                    // 翻页处理
                    this.loading = false
                    this.nextpage = false

                    if (notesinfo.length == 0 ) {
                            this.noMore = true
                    } else {

                        // 合并数组
                        this.notesinfo = this.notesinfo.concat(notesinfo)
                                    
                        if (notesinfo.length >= 10) {
                            this.nextpage = true
                        } else {
                            this.noMore = true
                        }
                    }
                })
            }
        },
        postNote() {    // 发布笔记

            // 判断用户是否登陆
            if (this.userIsLogin === false) {
                this.$message.info('请登录')
                this.setLoginPop(true)
            } else {

                if (this.noteData.length == 0 ) {
                    this.$message.error('请输入笔记内容')
                    return
                }

                // console.log(this.studyData)
                if (this.studyData.isjoin == 0) {
                    // 判断课程是否购买 
                    this.open()

                } else {
                    let postNodeDataApi= {  // 发布笔记接口参数
                        courseid: this.nodeDataApi.courseid, // 课程id
                        content: this.noteData, // 笔记内容
                        ispublic: this.checked == true? 0 : 1, // 是否公开 0 否 1是
                    }
                    this.setLoading(true)
                    uploadCourseNotes({
                        data: postNodeDataApi,
                        success:data => {
                            console.log(data)
                            this.setLoading(false)
                            if (data.code == '000') {
                                this.$message.success('发布成功')
                                // 调用列表
                                this.noteData = ''
                                this.handleClick(this.activeName)
                            } else {
                                this.$message.error(data.msg)
                            }
                        },
                        error:data => {
                            this.setLoading(false)
                            this.$message.error(data.msg)
                        }
                    })
                }
                
            }
        },
        open () {    // 弹窗
            this.$alert('你需要购买课程后才能发布笔记。', '温馨提示', {
                confirmButtonText: '立即购买',
                center: true,
                confirmButtonClass: 'gopay-btn'
            }).then(() => {
                this.$message({
                    type: 'success',
                    message: '前往购买!'
                });
            }).catch(() => {
            });
        },
        del (noteid) { // 删除笔记
            this.$confirm('此操作将永久删除该笔记, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    
                    this.setLoading(true)
                    deleteMyCourseNotes({
                        data: {noteid: noteid},
                        success: data => {
                            this.setLoading(false)
                            if (data.code == '000'){
                                this.$message.success('删除成功')

                                // 刷新列表
                                this.handleClick(this.activeName)
                            } else {
                                this.$message.error(data.msg)
                            }
                        },
                        error: data => {
                            this.setLoading(false)
                            this.$message.error(data.msg)
                        }
                    })


                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });          
            });
        },
        good () { // 点赞
            
        },
        ...mapActions(['setLoading','setLoginPop']),
        ...mapGetters(['user'])
    },
    filters: {},
    watch: {
        // 登陆信息发生变化
        getIsLogin() {
            console.log('登录状态发生变化')
            this.userIsLogin = this.user().isLogin
        }
    },
    computed: {
        getIsLogin() {
            return this.user().isLogin
        }
    },
    components: {}
    
}
</script>

<style lang="scss" type="text/scss" scope> 
.Note {
    padding: 0 20px;
    padding-bottom: 80px;

    .el-tabs .el-tabs__content {
        padding-bottom: 10px;
    }
    .next-page {
        margin-top: 10px;
        color: #999;
        font-size: 12px;
        text-align: center;
        cursor: pointer;
    }
    
    .tab-list {
        .el-tabs__item {
            width: calc(100% / 2) !important;
            background: #F8F8F8;
            font-size: 14px;
            color: #666;

            &.is-active {
                color: #409EFF;
            }

        }
        .el-tabs__active-bar {
            display: none;
        }
    }
    
    
    .position {
        clear: both;
        overflow: hidden;
    }
    .edit {
        .el-checkbox {
            margin-top: 25px;
        }
        .el-button {
            padding: 0 12px;
            margin-top: 20px;
            min-height: 29px;
            height: 29px;
            line-height: 29px;
        }
    }

    .comment-list {
        margin-top: 24px;

        .comment-head {
            margin-top: 12px;
            overflow: hidden;
            .img {
                float: left;
                margin-right: 20px;
                img {
                    display: block;
                    width: 46px;
                    height: 46px;
                    border-radius: 50%;
                    background: #ccc;
                }
            }
            .type {
                margin-left: 3px;
                display: inline-block;
                width:34px;
                height:16px;
                background:rgba(64,158,255,1);
                border-radius:2px;
                line-height: 16px;
                text-align: center;
                color: #fff;
                font-size:10px;
            }
            .title {
                float: left;
                width: calc(100% - 66px);
                .name {
                    margin-top: 3px;
                    font-size:14px;
                }
                .time {
                    margin-top: 10px;
                    font-size:14px;
                    color: #999;
                }
            }

        }
        .comment-msg {
            margin-top: 16px;
            padding-left: 66px;
            padding-bottom: 12px;
            border-bottom: solid 1px #E5E5E5;

            .msg {
                font-size: 14px;
                line-height: 20px;
                word-break: break-all;
                -ms-word-break: break-all;
            }
        }

        .position {
            p {
                margin-right: 12px;
                margin-top: 10px;
                padding-left: 20px;
                float: left;
                cursor: pointer;
                font-size: 12px;
                line-height: 18px;
                color: #999;
            }
            .active {
                color: #FF4747;
                &.icon-zan {
                    background: url('../../../../common/images/catalog/icon-zan-active.png') no-repeat 100%;
                    background-size: 14px;
                    background-position-x: 0;
                }

            }
            .icon-zan {
                background: url('../../../../common/images/catalog/icon-zan.png') no-repeat 100%;
                background-size: 14px;
                background-position-x: 0;
            }
            .icon-del {
                background: url('../../../../common/images/catalog/icon-del.png') no-repeat 100%;
                background-size: 14px;
                background-position-x: 0;
            }
        }
    }
}
</style>